import { createContext, useContext, useState, useEffect } from 'react';
import { DARK_THEME, LIGHT_THEME } from '../lib/theme';

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(() => {
    // Fast load from localStorage cache; Supabase prefs will overwrite via setIsDark
    try {
      const cached = JSON.parse(localStorage.getItem('sitescope-user-prefs'));
      if (cached && typeof cached.dark_mode === 'boolean') return cached.dark_mode;
    } catch { /* ignore */ }
    const legacy = localStorage.getItem('sitescope-theme');
    return legacy ? legacy === 'dark' : true;
  });

  const theme = isDark ? DARK_THEME : LIGHT_THEME;

  useEffect(() => {
    window.dispatchEvent(new Event('sitescope-theme-change'));
  }, [isDark]);

  const toggleTheme = () => setIsDark(prev => !prev);

  return (
    <ThemeContext.Provider value={{ theme, isDark, toggleTheme, setIsDark }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) throw new Error('useTheme must be used within ThemeProvider');
  return context;
}
